import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react'
import { usePublish, useView } from '@10000/react'

const context = createContext({})

export const useTooltipSeries = () => useContext(context)

export const TooltipSeries = ({ complete, onComplete, onReset, children, active }) => {
  const publish = usePublish('squiz')
  const { options } = useView('squiz')

  const [tip, setTip] = useState(complete ? -1 : 0)
  const orders = useRef(new Set())

  const onCompleteRef = useRef()
  onCompleteRef.current = onComplete
  const onResetRef = useRef()
  onResetRef.current = onReset

  const register = useCallback(
    x => orders.current = new Set(
      Array.from(orders?.current?.add(x))
      .sort((a, b) => a - b)
    ),
    [orders]
  )

  const next = useCallback(() => {
    if (tip === Array.from(orders.current)[orders.current.size - 1]) {
      onCompleteRef.current?.()
      setTip(-1)
    } else {
      const tipAfterCurrentValue = Array.from(orders.current).find(x => x > tip)
      setTip(tipAfterCurrentValue)
    }
  }, [onCompleteRef, tip])

  useEffect(() => {
    if(tip === 0 && orders?.current?.values().next().value !== 0) {
      setTip(orders?.current?.values().next().value)
    }
  }, [orders, tip])

  const skip = useCallback(
    () => {
      setTip(-1)
      onCompleteRef.current?.()
    },
    [onCompleteRef]
  )

  const reset = useCallback(
    guide => {
      if(options && guide) {
        publish('analyticsGuideCompleted', { guide, reset: true })
      }
      setTip(orders?.current?.values().next().value)
      onResetRef.current?.()
    },
    [onResetRef, options, publish, orders]
  )

  return (
    <context.Provider value={{ register, next, skip, reset, tip, active }}>
      {children}
    </context.Provider>
  )
}